/**
 * @internal
 */
var gestureProps = [
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
];

export { gestureProps };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/gestures/types.js
// module id = 102
// module chunks = 0